import React from 'react';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

import './style.scss';

const StudioBadge = () => (
    <span className="studio-badge">
        <I18n k={'gig_page_perseus.studio.studio'}/>
    </span>
);

export default StudioBadge;
